import React from 'react';

/** Photo of Swamiji — served from /public/img/swamiji.png. The Sun is a sibling. */
export const Swamiji: React.FC = () => (
  <div className="hero__swamiji-wrap">
    <img src={`${process.env.PUBLIC_URL}/img/swamiji.png`} alt="" draggable={false} />
  </div>
);
